import _ from 'underscore';
import template from '@bingads-webui-campaign-legacy/bidlandscape/template/keywordBidLandscape.pug';
import ViewModel from '@bingads-webui-campaign-legacy/bidlandscape/viewmodel/keyword';
import BaseView from '@bingads-webui-campaign-legacy/bidlandscape/view/bid-landscape';

export default class KeywordBidLandscape extends BaseView {
  initialize({
    parentItem = {},
    helpId = null,
    inSimpleMode = false,
    dataToShow = {},
  }) {
    super.initialize({
      viewModel: new ViewModel(parentItem, this),
      parentItem,
      helpId,
      inSimpleMode,
      dataToShow,
    });
  }

  prepareView() {
    this.$el.append(template(_.extend(this.viewModel, {
      Id: this.parentItem.Id,
      EntityName: this.parentItem.KeywordName,
    })));
  }
}
